
import { useState } from "react"
import { useDispatch } from "react-redux"
import styled from "styled-components"
import { updateYukData } from "../../../../../features/addLoad/addLoadSlice"
import { useEffect } from "react"
import { useSelector } from "react-redux"

const Container = styled.div`
    width: 260px;
    height: 40px;
    filter: none !important;
    background-color: ${({theme}) => theme.mainBgColor};
    position: relative;

    input{
        width: 100%;
        height: 100%;
        padding: 10px 20px;
        font-size: var(--font-size-sm);
        font-weight: var(--font-weight-md);
        border: 1px solid ${({theme, isActive, isError}) => isError ? "var(--color-red)" : isActive? "#E85446" : theme.mainBorderColor};
        border-radius: ${({radius}) => radius};
        color: var(--color-dark);
        background-color: ${({theme}) => theme.mainBgColor};

        &:-webkit-autofill,
        &:-webkit-autofill:hover, 
        &:-webkit-autofill:focus, 
        &:-webkit-autofill:active{
            -webkit-box-shadow: 0 0 0 30px white inset !important;
        }
    }

    input:focus ~ label{
        color: ${({theme}) => theme.mainTextColor};
        transform: translateY(-22px);
    }

    label{
        position: absolute;
        transform: ${({value}) => value && "translateY(-22px)"};
        bottom: 12px;
        left: 20px;
        font-size: 12px;
        font-weight: var(--font-weight-lg);
        pointer-events: none;
        transition:  all .3s ease;
        z-index: 5;
        color: ${({theme, value}) => value ? theme.mainTextColor : theme.secondaryTextColor};
        background-color: ${({theme}) => theme.mainBgColor};
    }

    p{
        font-size: 11px;
        font-weight: var(--font-weight-lg);
        color: var(--color-main);
        padding-top: 5px;
        padding-left: 5px;
    }
`

const ToplamAgirlikInput = ({data, isRequired, name}) => {

    const {showErrors, showRequiredPlaces, yukData} = useSelector(state => state.addLoad)
    const [isError, setIsError] = useState(false)
    const dispatch = useDispatch()

    const [maxError, setMaxError] = useState(false)

    const handleChange = (e) => {


        if(yukData.agirlikBirim?.value === 1 && parseInt(e.target.value.replace(/[^0-9]/g, '')) > 30){
            dispatch(updateYukData({toplamAgirlik: 30}))
            setMaxError(true)
        }

        else{
            dispatch(updateYukData({toplamAgirlik: e.target.value.replace(/[^0-9]/g, '')}))
            setMaxError(false)
        }
    }

    useEffect(() => {
        //! bu submit esnasında boş girerse gösterilecek 
        if(isRequired && !data.toplamAgirlik && showErrors){
            return setIsError(true)
        }
        //! bu kullanıcı zorunlu alanları görüntülemek isterse
        if(isRequired && showRequiredPlaces){
           return setIsError(true)
        }
        else{
            setIsError(false)
        }
    },[isRequired, data.toplamAgirlik, showRequiredPlaces, showErrors])

    
  return (
    <Container value={data.toplamAgirlik} radius={"5px"} isError={isError}>
            <input type="text" onChange={handleChange} value={data.toplamAgirlik}/>
        <label htmlFor={"text"}>Yükün Toplam Ağırlığı {isRequired && " (Zorunlu)"}</label>
        {
            maxError && <p>Toplam ağırlık en fazla 30 ton olabilir!</p>
        }
    </Container>
  )
}

export default ToplamAgirlikInput